import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

import {
  isPendingAction,
  isRejectedAction,
  isFulfilledAction
} from './actions';

import { paymentData } from './mockData/paymentData';

const name = 'payments';

export const getPayments = createAsyncThunk(
  `${name}/getPayments`,
  async (_, { rejectWithValue }) => {
    try {
      //const responseFromApi = await axios.get('/api/payments');

      const response = paymentData;
      return response;
      //return responseFromApi;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const paymentSlice = createSlice({
  name,
  initialState: {
    loading: false,
    errors: false,
    payments: paymentData
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPayments.fulfilled, (state, action) => {
        const { payments } = action.payload;
        state.payments = payments;
      })
      .addMatcher(isPendingAction(name), (state) => {
        state.loading = true;
        state.errors = false;
      })
      .addMatcher(isRejectedAction(name), (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addMatcher(isFulfilledAction(name), (state) => {
        state.loading = false;
      });
  }
});

export default paymentSlice.reducer;
